/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ad-host{display:block;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;max-width:100%;overflow:hidden}ad-host:empty{display:none}ad-host.margin-bottom{margin-bottom:15px}ad-host.margin-top{margin-top:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/ui/ad-host/ad-host.component.scss.ngstyle.js.pre-build-optimizer.js